import {ErrorWrapper, ResponseWrapper} from "@/core/service/util";
import {RoomBaseApiService} from "@/core/service/room.baseapi.service";

export class RoomCoordiService extends RoomBaseApiService {
    constructor() {
        super()
    }
    async getUserStickerList({roomId, userId}){
        try{
            const response = await this.request().get(`/api/v3/camstudy/${roomId}/users/${userId}/sticker`);
            return new ResponseWrapper(response, response.data.data)
        }catch(error){
            throw new ErrorWrapper(error)
        }
    }
    async getStickerList(keyword){
        try{
            const response = await this.request().get(`/api/v3/item/list/search/category?keyword=${keyword}`);
            return new ResponseWrapper(response, response.data.data)
        }catch(error){
            throw new ErrorWrapper(error)
        }
    }
    async getPurchaseStickerList() {
        let res = await this.request().get(`/api/v3/userInfo/sticker`);
        return res.data.data?.itemList;
    }
    async getStickerItems(itemId){
        try{
            const response = await this.request().get(`/api/v3/item/${itemId}/sticker/list`);
            return new ResponseWrapper(response, response.data.data)
        }catch(error){
            throw new ErrorWrapper(error)
        }
    }
    async setUserSticker({roomId, userId, stickers}){
        if(!userId) {
            userId = 'me';
        }
        try{
            const response = await this.request().post(`/api/v3/camstudy/${roomId}/users/${userId}/sticker`, stickers);
            return new ResponseWrapper(response, response.data.data)
        }catch(error){
            throw new ErrorWrapper(error)
        }
    }
}

export const roomCoordiService = new RoomCoordiService();